export default "__VITE_ASSET__SYqs1AxP__"